import { Controller } from 'stimulus';

import universalTracking from '../tracking/universalTracking';
import delegatedEventListener from '../helpers/delegatedEventListener';

class Tracking extends Controller {
  // eslint-disable-next-line class-methods-use-this
  connect() {
    Tracking.trackLinks();
  }

  static trackLinks() {
    delegatedEventListener('click', 'a', document, ({ target }) => {
      if (target.matches('a[href^="tel:"]')) {
        universalTracking.event('phone', 'click', target.href);
        return;
      }

      if (target.matches('a[href^="mailto:"]')) {
        universalTracking.event('mail', 'click', target.href);
        return;
      }

      if (
        target.href.indexOf(window.location.host) <= 0
        && target.href.match(/^http/i)
      ) {
        universalTracking.event('outbound', 'click', target.href);
      }
    });
  }
}

Tracking.targets = [
  //
];

export default Tracking;
